<script lang="ts">
	import { run } from 'svelte/legacy';

	import { onNavigate, type OnNavigate } from '$app/navigation';
	import { navigating } from '$app/state';
	import SubMenus from './SubMenus.svelte';

	import '@picocss/pico/css/pico.orange.css';
	// Do not remove this comment, it prevent prettier to reorder imports
	import './global-styles.css';
	// Do not remove this comment, it prevent prettier to reorder imports
	import './admonition.css';
	// Do not remove this comment, it prevent prettier to reorder imports
	import './global-view-transitions.css';
	// Do not remove this comment, it prevent prettier to reorder imports
	import 'uno.css';

	let { children } = $props();

	let tooFast = $state(false);

	run(() => {
		if (navigating.to !== null) {
			tooFast = true;
			setTimeout(() => (tooFast = false), 250);
		}
	});

	function isBackNavigation({ from, to }: OnNavigate): boolean {
		if (from === null || to === null) return false;

		return from.url.pathname !== to.url.pathname && from.url.pathname.startsWith(to.url.pathname);
	}

	function isSamePageNavigation({ from, to }: OnNavigate): boolean {
		if (from === null || to === null) return false;

		return from.url.pathname === to.url.pathname;
	}

	onNavigate((navigation) => {
		if (navigation.shallow) return;

		//@ts-ignore
		if (!document.startViewTransition) return;

		if (isBackNavigation(navigation)) {
			document.documentElement.classList.add('back-transition');
		}

		if (isSamePageNavigation(navigation)) {
			document.documentElement.classList.add('same-page-navigation');
		}

		return new Promise(async (resolve) => {
			//@ts-ignore
			const transition = document.startViewTransition(async () => {
				resolve();
				await navigation.complete;
			});

			try {
				await transition.finished;
			} catch (e) {
				console.error(e);
			} finally {
				document.documentElement.classList.remove('back-transition', 'same-page-navigation');
			}
		});
	});
</script>

{#if navigating.to !== null && !tooFast}
	<progress fixed h-1 border rounded-none z-2></progress>
{/if}

<div flex="~ col" h-full>
	<nav shadow-xl class="container-fluid [view-transition-name:top-nav]" pl-0 z-1>
		<ul>
			<li py-2>
				<a
					href="/"
					flex
					items-center
					gap-2
					py-0
					decoration="none hover:none"
					text="hover:primary focus:primary"
				>
					<div bg-primary-background w-11 h-11 flex items-center justify-center>
						<i i-twemoji-ant block w6 h6 class="-scale-x-100"></i>
					</div>

					Mapant.fr
				</a>
			</li>
		</ul>

		<ul>
			<SubMenus />
		</ul>
	</nav>

	{@render children?.()}
</div>
